import { TRange } from '../../../node.type'

export function getValidSortedRanges(ranges: TRange[]): TRange[] {
  return ranges
    .filter((r) => !isNaN(r.lowerBound) && !isNaN(r.upperBound))
    .sort((a, b) => a.lowerBound - b.lowerBound)
}

export function createRange(lowerBound: number, upperBound: number): TRange {
  return {
    lowerBound,
    upperBound,
    action: {},
  }
}

export function areAllValuesCovered(ranges: TRange[], minValue: number, maxValue: number): boolean {
  const sortedRanges = getValidSortedRanges(ranges)

  if (sortedRanges.length === 0) return false

  const firstRange = sortedRanges[0]
  if (!firstRange || firstRange.lowerBound !== minValue) return false

  const lastRange = sortedRanges[sortedRanges.length - 1]
  if (!lastRange || lastRange.upperBound !== maxValue) return false

  for (let i = 0; i < sortedRanges.length - 1; i++) {
    const currentRange = sortedRanges[i]
    const nextRange = sortedRanges[i + 1]
    if (currentRange && nextRange && currentRange.upperBound + 1 !== nextRange.lowerBound) {
      return false
    }
  }

  return true
}
